import ProductFileOrUpload from "./product-file-or-upload";
import { ProductFileWrap, ProductAudioFileWrap } from "./file-wrap";

export {
    ProductFileWrap,
    ProductAudioFileWrap
}

export default ProductFileOrUpload;